<header class="header">
  <div class="left">
    <ng-content select="[left]"></ng-content>
  </div>

  <div class="center">
    <ng-content select="[center]"></ng-content>
  </div>

  <div class="right">
    <ng-content select="[right]"></ng-content>
    @if (!hideExit) {
      <button class="exit" (click)="exit()" [disabled]="isRunningProcess">
        <span class="label">Exit</span> <i class="icon icon-exit"></i>
      </button>
    }
  </div>
</header>
